import { useWebRedirect } from './useWebRedirect';

/**
 * Route component behind the external web redirect entry point. Delegates the redirect work to useWebRedirect and renders no markup.
 *
 * @returns Null, since the component renders nothing.
 */
const WebRedirect = (): any => {
  useWebRedirect();

  return null;
};

export default WebRedirect;
